import { Text } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { ZSL_ASSET_TYPES } from "src/constants/constants";
import { isZSLAssetWithZdl, isParamArray } from "src/utils/zslTypeguard";
import { Template } from "src/types";
import styles from "./CreatedAssetsSection.module.css";
import { replaceParamsInTitle } from "src/utils/replaceParamsInTitle";

type Props = {
  template: Template;
};

/**
 * CreatedAssetsSection is a component that displays a list of created assets for a template.
 */
export const CreatedAssetsSection = ({ template }: Props) => {
  return (
    template.zsl && (
      <section>
        <Text
          type="ParagraphHeader2"
          className={styles.sidebarSectionTitle}
          tag="h2"
        >
          Created assets
        </Text>
        <div className={styles.assetTypes}>
          {ZSL_ASSET_TYPES.map((assetType) => {
            const items = template.zsl?.[assetType.name];

            if (!items || items.length === 0 || !Array.isArray(items))
              return null;

            return (
              <div className={styles.assetType} key={assetType.name}>
                <Text type="MinimalPrint3">{`${assetType.displayName} (${items.length})`}</Text>
                <ul className={styles.assetTypeItems}>
                  {items.map((item) => {
                    const zslParameters = template.zsl?.parameters;

                    if (isZSLAssetWithZdl(item)) {
                      return (
                        <li className={styles.assetTypeItem} key={item.id}>
                          <Icon
                            name={assetType.icon}
                            color="BrandOrange"
                            size={18}
                            className={styles.assetIcon}
                          />
                          <Text type="Body3">
                            {replaceParamsInTitle(
                              item.name ||
                                item.title ||
                                item.config?.chatbotName ||
                                "Untitled",
                              isParamArray(zslParameters) ? zslParameters : [],
                            )}
                          </Text>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </section>
    )
  );
};
